angular.module('capability-ng-scheduler').directive('frameScroll', function frameScroll($timeout: any) {
  return {
    restrict: 'A',
    scope: {
      framescrollTarget: '@'
    },
    link(scope: any, element: any, attrs: any) {
      const target = document.getElementById(scope.framescrollTarget);
      scope.scrollToTarget = function scrollToTarget() {
        $timeout(() => {
          if (target) {
            target.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100);
      };

      element.on('click', scope.scrollToTarget);

      scope.$on('$destroy', () => {
        element.off('click', scope.scrollToTarget);
      });
    }
  };
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/frame_scroll/frame_scroll.ts